class ProductRecommendations extends HTMLElement {
  constructor() {
    super()

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          const swiperEl = this.querySelector('swiper-container')
          const _this = this
          const swiperOptions = {
            slidesPerView: 1.2,
            spaceBetween: 15,
            centeredSlides: true,
            centeredSlidesBounds: true,
            loop: true,
            on: {
              afterInit: function () {
                _this.querySelectorAll('swiper-slide').forEach((slide) => {
                  slide.style.height = `${swiperEl.clientHeight}px`
                })
              },
            },
            breakpoints: {
              768: {
                slidesPerView: 3.5,
              },
            },
          }

          Object.assign(swiperEl, swiperOptions)
          swiperEl.initialize()
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this)
  }
}

customElements.define('product-recommendations', ProductRecommendations)
